module.exports = __webpack_public_path__ + "img/role_2.b76875e5.png";